/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../index.js";
export function IconChromecastConnectingTwo(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M.667 9.333v1.334c.92 0 1.706.325 2.357.976.65.65.976 1.436.976 2.357h1.333c0-.635-.123-1.24-.369-1.817a4.666 4.666 0 0 0-.992-1.489 4.67 4.67 0 0 0-1.488-.992 4.583 4.583 0 0 0-1.817-.369zM14 2H2a1.28 1.28 0 0 0-.94.393 1.283 1.283 0 0 0-.393.94v2H2v-2h12v9.334H9.333V14H14c.365 0 .679-.131.94-.393.262-.262.393-.575.393-.94V3.333c0-.365-.131-.678-.393-.94A1.28 1.28 0 0 0 14 2z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M1 14v2c1.38 0 2.56.488 3.536 1.465C5.512 18.44 6 19.619 6 21h2c0-.953-.184-1.861-.553-2.726a7.016 7.016 0 0 0-1.489-2.232 7.004 7.004 0 0 0-2.232-1.488A6.877 6.877 0 0 0 1 14zM21 3H3c-.547 0-1.018.196-1.41.59C1.195 3.982 1 4.452 1 5v3h2V5h18v14h-7v2h7c.547 0 1.018-.197 1.41-.59.394-.392.59-.862.59-1.41V5a1.92 1.92 0 0 0-.59-1.411A1.926 1.926 0 0 0 21 3z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconChromecastConnectingTwo is deprecated and will be archived soon. Use IconChromecastConnectingTwo instead.
 */
export function Experimental__IconChromecastConnectingTwo(props) {
  return /*#__PURE__*/React.createElement(IconChromecastConnectingTwo, props);
}